@if (quoteRequestForm !== undefined) {
<cipx-quote-request-intake-form-request-details-screen-and-explain
  [quoteRequestForm]="
    quoteRequestForm
  "></cipx-quote-request-intake-form-request-details-screen-and-explain>

<div [formGroup]="quoteRequestForm">
  <div class="cipx-form-section">
    <fieldset>
      <legend class="cipx-form-section-title">Any additional comments?</legend>

      <div class="cipx-form-form-group">
        <mat-form-field
          [subscriptSizing]="'dynamic'"
          [hideRequiredMarker]="true">
          <textarea
            matInput
            formControlName="additional_comments"
            rows="3"></textarea>
        </mat-form-field>
      </div>
    </fieldset>
  </div>
</div>
<!-- <div class="cipx-form-form-group text-right">
  <button mat-flat-button color="primary" type="submit">Request Quote</button>
</div> -->
}
